export const createLinkFeatures = (editor) => ({
  addLink(url) {
    if (!editor) return;
    if (url) {
      editor.chain().focus().setLink({ href: url }).run();
    }
  },

  removeLink() {
    if (!editor) return;
    editor.chain().focus().unsetLink().run();
  }
});
